import React from 'react';
import { X, Check } from 'lucide-react';
const comparisonData = [{
  sin: '3-5 hs/semana planificando desde cero',
  con: '10 min/semana. El resto es enseñar.'
}, {
  sin: 'Siempre los mismos pasos y combinaciones',
  con: '60+ recursos y clases distintas listas'
}, {
  sin: 'Alumnos que abandonan sin saber por qué',
  con: 'Progresión → retención visible'
}, {
  sin: 'Sin progresión clara de nivel a nivel',
  con: '6 tomos con planificación anual completa'
}, {
  sin: 'Grupo heterogéneo = caos en la clase',
  con: 'Recursos para gestionar cualquier nivel en la misma clase'
}, {
  sin: 'Sin variedad = alumnos aburridos',
  con: 'Banco de combinaciones para meses de variedad'
}, {
  sin: 'Sin sistema de comunicación',
  con: 'Guía completa con mensajes listos para usar'
}, {
  sin: 'Sin identidad profesional visible',
  con: 'Sistema que justifica cobrar más'
}];
const emojis = ['⏰', '😓', '💸', '📋', '😨', '👥', '📱', '💼'];
export function ComparisonSection() {
  return <section className="py-12 md:py-24 bg-neutral-900 border-t border-neutral-800" data-id="element-46">
      <div className="container mx-auto px-4" data-id="element-47">
        <div className="text-center mb-8 md:mb-16" data-id="element-48">
          <h2 className="text-2xl md:text-5xl font-black text-white mb-2 md:mb-4" data-id="element-49">
            RITMOS LATINOS RESUELTO™
          </h2>
          <p className="text-sm md:text-xl text-neutral-300 mb-1 md:mb-2" data-id="element-50">
            El próximo lunes podés volver a improvisar la clase.
          </p>
          <p className="text-base md:text-xl text-amber-500 font-bold mb-4 md:mb-8" data-id="element-51">
            O podés entrar al gimnasio o academia con todo resuelto desde hoy.
          </p>
          <h3 className="text-xl md:text-2xl font-black text-white" data-id="element-52">
            ¿Cuánto cuesta NO tenerlo?
          </h3>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-2 gap-3 md:gap-8" data-id="element-53">
          {/* SIN Card */}
          <div className="bg-neutral-950 border border-neutral-800 rounded-2xl md:rounded-3xl p-4 md:p-8" data-id="element-54">
            <div className="flex items-center justify-center gap-1.5 text-lg md:text-2xl font-black text-red-500 mb-4 md:mb-8 pb-3 md:pb-6 border-b border-neutral-800" data-id="element-55">
              <X className="w-5 h-5 md:w-8 md:h-8" data-id="element-56" /> SIN:
            </div>
            <ul className="space-y-3 md:space-y-6" data-id="element-57">
              {comparisonData.map((item, idx) => <li key={idx} className="flex items-start gap-2 md:gap-4 text-neutral-400 text-xs md:text-base" data-id="element-58">
                  <span className="text-sm md:text-xl shrink-0" data-id="element-59">
                    {emojis[idx]}
                  </span>
                  <span data-id="element-60">{item.sin}</span>
                </li>)}
            </ul>
          </div>

          {/* CON Card */}
          <div className="bg-gradient-to-b from-neutral-900 to-neutral-950 border-2 border-amber-500 rounded-2xl md:rounded-3xl p-4 md:p-8 shadow-[0_0_30px_rgba(245,158,11,0.1)]" data-id="element-61">
            <div className="flex items-center justify-center gap-1.5 text-lg md:text-2xl font-black text-amber-500 mb-4 md:mb-8 pb-3 md:pb-6 border-b border-neutral-800" data-id="element-62">
              <Check className="w-5 h-5 md:w-8 md:h-8" data-id="element-63" /> CON:
            </div>
            <ul className="space-y-3 md:space-y-6" data-id="element-64">
              {comparisonData.map((item, idx) => <li key={idx} className="flex items-start gap-2 md:gap-4 text-white font-medium text-xs md:text-base" data-id="element-65">
                  <span className="text-sm md:text-xl shrink-0" data-id="element-66">
                    {emojis[idx]}
                  </span>
                  <span data-id="element-67">{item.con}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}